import { Button } from "../../Atoms/Button";
import { Eye } from "../../Atoms/Eye";
import { Pagination } from "../../Atoms/Pagination";
import { SimpleSelect } from "../../Atoms/Selects/SimpleSelect";
import { Status } from "../../Atoms/Status";
import { Title } from "../../Atoms/Title";
import { v4 } from "uuid";

import * as S from "./styles";
import { useAdminDeliverys } from "./useAdminDeliverys";
import { ISelectOptions } from "../../../types/inputs";

export const AdminDeliverysTemplate = () => {
  const {
    isOpen,
    setIsOpen,
    isMobile,
    pagination,
    setNumberPage,
    navigate,
    ufOptions,
    Controller,
    cidadesOptions,
    control,
    handleSubmit,
    reset,
    watch,
    handleFilter,
    deliverys,
    handleReset,
    canEditDeliveries,
    canAccessDeliveries,
  } = useAdminDeliverys();

  return (
    <S.Container>
      <S.Wrapper>
        <Title>Delliverys cadastradas</Title>

        <S.WrapperButtons>
          <Button
            data-variant-outline
            onClick={() => setIsOpen((prev) => !prev)}
          >
            <img src="/assets/svgs/filter-dark.svg" alt="iconf filter" />{" "}
            Filtrar
          </Button>
          {canEditDeliveries ? (
            <Button
              data-variant-outline
              onClick={() => navigate("/configuracoes/deliverys/cadastro")}
            >
              <img src="/assets/svgs/icon-plus.svg" alt="icon plus" /> Cadastrar
            </Button>
          ) : (
            <></>
          )}
        </S.WrapperButtons>
        {isOpen && (
          <S.FilterDelivery onSubmit={handleSubmit(handleFilter)}>
            <div>
              <Controller
                control={control}
                name="uf"
                render={({ field: { onChange, value } }) => (
                  <SimpleSelect
                    inputId="uf"
                    label="UF"
                    required
                    options={ufOptions}
                    value={ufOptions.find((i) => i.value === value) || null}
                    onChange={(e: ISelectOptions) => onChange(e?.value)}
                  />
                )}
              />
            </div>
            <div>
              <Controller
                control={control}
                name="cidade"
                render={({ field: { onChange, value } }) => (
                  <SimpleSelect
                    required
                    options={cidadesOptions}
                    key={`${Math.random()} - ${watch("uf")}`}
                    value={
                      cidadesOptions.find((i) => i.value === value) || null
                    }
                    inputId="cidade"
                    onChange={(e: ISelectOptions) => onChange(e?.value)}
                    label="Cidade"
                  />
                )}
              />
            </div>

            <div>
              <Button
                data-variant-text
                type="button"
                onClick={() => {
                  reset();
                  handleReset();
                }}
              >
                Limpar Tudo
              </Button>
              <Button>Buscar</Button>
            </div>
          </S.FilterDelivery>
        )}

        {canAccessDeliveries && deliverys?.length > 0 && (
          <S.Table>
            {deliverys.map((i) => (
              <S.TableItem>
                <p>
                  CIDADE: <span>{i?.cidade}</span>
                </p>

                <p>
                  STATUS: <span>{i.ativo ? "ATIVO" : "INATIVO"}</span>
                </p>

                {canEditDeliveries ? (
                  <Eye
                    onClick={() =>
                      navigate(`/configuracoes/deliverys/detalhe?id=${i.uuid}`)
                    }
                  />
                ) : (
                  <></>
                )}
              </S.TableItem>
            ))}
          </S.Table>
        )}

        {canAccessDeliveries && deliverys.length > 0 && (
          <Pagination
            maxPageNumbersDisplayed={isMobile ? 3 : 10}
            key={`${Math.random()} - ${pagination}`}
            totalPage={pagination.totalPage}
            totalRegister={pagination.totalPage}
            actualPage={pagination.actualPage}
            setNumberPage={setNumberPage}
          />
        )}
      </S.Wrapper>
    </S.Container>
  );
};
